import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LOCK_ICON } from '../../../../constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { DiscountLabelProps } from './useDiscountLabelModel'
import { DiscountLabel as DiscountLabelUnified } from './DiscountLabel'
import { DiscountLabelLegacy } from './DiscountLabelLegacy'

export const DiscountLabel: React.FC<DiscountLabelProps> = props => {
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LOCK_ICON
  )

  return isUnifiedEnabled ? (
    <DiscountLabelUnified {...props} />
  ) : (
    <DiscountLabelLegacy {...props} />
  )
}
